import { render, staticRenderFns } from "./FeatureLockedNotify.vue?vue&type=template&id=a8637242&scoped=true"
import script from "./FeatureLockedNotify.vue?vue&type=script&lang=ts"
export * from "./FeatureLockedNotify.vue?vue&type=script&lang=ts"
import style0 from "./FeatureLockedNotify.vue?vue&type=style&index=0&id=a8637242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8637242",
  null
  
)

export default component.exports